import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["visible", "title", "onClose", "bgColor", "children", "zIndex", "wide", "closable", "backdropClosable", "alignCenter", "scrollable"];

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/Modal/Modal.js",
    _this = this;

import React, { useRef, useEffect, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { Transition } from 'react-transition-group';
import CloseIcon from '@dls/assets/icons/Close';
import { noop, testIdProps } from '../../helpers';
import { withTheme, useTheme } from '../../core/ThemeProvider';
import getRandomId from '../../core/utils/getRandomId';
import { Fade, FADE_OUT_DURATION, FADE_IN_DURATION } from './animation';
import { Grid, Row, Column } from '../..';
import ModalContent from './ModalContent';
import ModalFooter from './ModalFooter';
import { AnimationWrapper, CloseWrapper, ModalContainer, NoBackgroundActivity, Wrapper } from './styles';
export var ModalContext = /*#__PURE__*/React.createContext();
var CloseButton = withTheme(function (_ref) {
  var _coreTheme$modal;

  var onClick = _ref.onClick,
      coreTheme = _ref.coreTheme;
  return /*#__PURE__*/React.createElement(CloseWrapper, {
    onClick: onClick,
    "data-testid": "modal-closeBtn",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    color: ((_coreTheme$modal = coreTheme.modal) === null || _coreTheme$modal === void 0 ? void 0 : _coreTheme$modal.iconColor) || coreTheme.cl_sec_d1,
    size: 22,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 5
    }
  }));
});

var Modal = function Modal(props) {
  var visible = props.visible,
      title = props.title,
      onClose = props.onClose,
      bgColor = props.bgColor,
      children = props.children,
      zIndex = props.zIndex,
      wide = props.wide,
      closable = props.closable,
      backdropClosable = props.backdropClosable,
      alignCenter = props.alignCenter,
      scrollable = props.scrollable,
      rest = _objectWithoutProperties(props, _excluded);

  var _useTheme = useTheme(),
      theme = _useTheme.theme;

  var modalRef = useRef(null);

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      exited = _React$useState2[0],
      setExited = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      hasStickyFooter = _React$useState4[0],
      setHasStickyFooter = _React$useState4[1];

  if (typeof document === 'undefined') {
    return null;
  }

  var body = document.getElementsByTagName('body')[0];
  var modalNode = useMemo(function () {
    var node = document.querySelector('[id^="modal-root-"]');

    if (!node && visible) {
      node = document.createElement('div');
      node.setAttribute('id', "modal-root-".concat(getRandomId()));
      body.appendChild(node);
    }

    return node;
  }, [visible]);
  useEffect(function () {
    !visible && exited && body.contains(modalNode) && body.removeChild(modalNode);
  }, [visible, exited]);
  useEffect(function () {
    for (var child in children) {
      var _children$child;

      if (((_children$child = children[child]) === null || _children$child === void 0 ? void 0 : _children$child.type) === ModalFooter) {
        setHasStickyFooter(true);
      }
    }
  }, []); // Close modal if clicking outside of modal content

  var handleClickOverlay = function handleClickOverlay(event) {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose(event);
    }
  };

  var backdropClickable = function backdropClickable() {
    return backdropClosable && {
      onClick: handleClickOverlay
    };
  }; //returns null when animation exited


  if (!visible && exited) return null;
  var modalElement = /*#__PURE__*/React.createElement(AnimationWrapper, {
    zIndex: zIndex,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Transition, {
    appear: true,
    timeout: visible ? FADE_IN_DURATION : FADE_OUT_DURATION,
    "in": visible,
    mountOnEnter: true,
    unmountOnExit: true,
    onEnter: function onEnter() {
      setExited(false);
    },
    onExited: function onExited() {
      setExited(true);
    },
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 7
    }
  }, function (state) {
    var _theme$modal;

    return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement(NoBackgroundActivity, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 116,
        columnNumber: 25
      }
    }), /*#__PURE__*/React.createElement(Fade, {
      state: state,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(ModalContainer, _extends({
      alignCenter: alignCenter
    }, testIdProps(rest), backdropClickable(), {
      scrollable: scrollable,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 118,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(Grid, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 124,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Row, {
      center: "xs",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 125,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Column, {
      xs: 12,
      sm: 12,
      md: wide ? ((_theme$modal = theme.modal) === null || _theme$modal === void 0 ? void 0 : _theme$modal.maxWide) || 8 : 6,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 126,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(Wrapper, {
      "data-testid": "modalWrapperId",
      ref: modalRef,
      hasTitle: !!title,
      bgColor: bgColor,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 131,
        columnNumber: 23
      }
    }, /*#__PURE__*/React.createElement(ModalContext.Provider, {
      value: {
        scrollable: scrollable,
        visible: visible,
        title: title,
        hasStickyFooter: hasStickyFooter
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 137,
        columnNumber: 25
      }
    }, children), closable && /*#__PURE__*/React.createElement(CloseButton, {
      onClick: onClose,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 147,
        columnNumber: 38
      }
    }))))))));
  }));
  return /*#__PURE__*/createPortal(modalElement, modalNode);
};

Modal.defaultProps = {
  onClose: noop,
  bgColor: 'white',
  zIndex: 1000,
  backdropClosable: true,
  alignCenter: false,
  closable: true
};
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
export default Modal;